export const types = {
  REAL_TIME_PRICING_DRAWER_OPEN:
    'modules/quotes/quoteItemComponents/adjustDirectPricingDrawer/REAL_TIME_PRICING_DRAWER_OPEN',
  REAL_TIME_PRICING_DRAWER_CLOSE:
    'modules/quotes/quoteItemComponents/adjustDirectPricingDrawer/REAL_TIME_PRICING_DRAWER_CLOSE',
};

export const realTimePricingDrawer = {
  close: () => ({
    type: types.REAL_TIME_PRICING_DRAWER_CLOSE,
  }),
  open: ({ realTimePricingPlan, componentId }) => ({
    type: types.REAL_TIME_PRICING_DRAWER_OPEN,
    payload: { realTimePricingPlan, componentId },
  }),
};
